module.exports = __webpack_public_path__ + "img/view-stacked.d4d93823.svg";